import { CURRENT_VERSION } from '../data-model';
import { toStoredMigrations, seedMigrationsDocument as libSeedMigrations, deleteMigrationsDocument, getMigrationsDocument } from '@luzula/luzula-lib';
import { ALL_MIGRATIONS } from './all-migrations';

/** Alle Migrationen als StoredMigration-Objekte (Strings für DB) */
export const STORED_MIGRATIONS = toStoredMigrations(ALL_MIGRATIONS);

/**
 * Erstellt oder aktualisiert das _design/migrations Dokument in CouchDB.
 */
export async function seedMigrationsDocument(db: PouchDB.Database): Promise<boolean> {
  return libSeedMigrations(db, CURRENT_VERSION, STORED_MIGRATIONS);
}

export { deleteMigrationsDocument, getMigrationsDocument };
